import { create } from "zustand";

export interface IDialogOptions {
  disableOutsideClick?: boolean;
}

export interface ICompanyStore {
  companyId: string | null;
  currentUrl: string | null;
  setCompanyId: (companyId: string) => void;
  setCurrentUrl: (currentUrl: string) => void;
}

const useCompanyStore = create<ICompanyStore>((set) => ({
  companyId: null,
  currentUrl: null,
  setCompanyId: (id) => set({ companyId: id }),
  setCurrentUrl: (url) => set({ currentUrl: url }),
}));

export default useCompanyStore;
